import { useState } from 'react';
import { SortingDirectionsType } from '~src/types';

export default function<T extends string>(
  defaultSortField: T,
  defaultSortingDirection: SortingDirectionsType,
) {
  const [sortingDirection, setSortingDirection] = useState(
    defaultSortingDirection,
  );
  const [sortField, setSortField] = useState<T>(defaultSortField);

  const sortByField = (field: T, sortingDirection: SortingDirectionsType) => {
    setSortField(field);
    setSortingDirection(sortingDirection);
  };

  return {
    sortingDirection,
    sortField,
    sortByField,
    setSortField,
    setSortingDirection,
  };
}
